import React from 'react';
import Grid from 'components/Custom/Grid';
import { getWeatherImpacts } from 'utils/WeatherImpactUtils';
import WeatherImpact from 'classes/WeatherImpact';
import { useAppContext } from 'hooks/useAppContext';

export default function WeatherImpactGrid() {
  const columns = WeatherImpact.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Weather Impact"
      getRecords={getWeatherImpacts}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
